import { ToastContainer } from 'react-toastify';

/**
 * ToastProvider — mounts react-toastify's `<ToastContainer>` with the
 * webapp's shared configuration (top-right, 5s autoClose, light theme,
 * high z-index so toasts sit above modals). Render once at the root of
 * the app tree.
 */
export function ToastProvider() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      toastClassName="toast-custom"
      style={{ zIndex: 99999 }}
    />
  );
}

export default ToastProvider;
